
<template>
  <div id="app">

<!--    <img src="./assets/logo.png">-->
    <router-view/>
  </div>
</template>

<script type="text/javascript" rel="stylesheet">



window.onload = function() {
  document.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
      event.preventDefault()
    }
  })
  document.addEventListener('gesturestart', function(event) {
    event.preventDefault()
  })
}
export default {
  name: 'app'
}
</script>

<style>
@media screen and (min-width: 751px) {
  body {
    background-color: #ececec;
  }
  #app {
    max-width: 750px;
    min-height: 100vh;
    margin: 0 auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    position: relative;
    overflow-x: hidden;
    contain: layout;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue